import React from 'react';

export default function Pattern() {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0 w-full h-full">
      <defs>
        <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
          <path d="M 60 0 L 0 0 0 60" fill="none" stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.1"/>
          <circle cx="0" cy="0" r="1" fill="currentColor" fillOpacity="0.1"/>
          <circle cx="60" cy="0" r="1" fill="currentColor" fillOpacity="0.1"/>
          <circle cx="0" cy="60" r="1" fill="currentColor" fillOpacity="0.1"/>
          <circle cx="60" cy="60" r="1" fill="currentColor" fillOpacity="0.1"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)"/>
    </svg>
  );
} 